import React from "react";
import { Link } from "react-router-dom";
import styles from "./FooterItems1.module.css";
import useMediaQueryHook from "../../hooks/useMediaQueryHook";

export const FooterItemsRow1 = ({ sections, current, setCurrent }) => {
  const { isTabletOrMobile } = useMediaQueryHook();
  return (
    <div className={styles.footer_categories_container}>
      {sections.map((cat) => {
        const { section, subSections } = cat;
        return (
          <div
            onClick={() => {
              isTabletOrMobile &&
                setCurrent({ element: section, open: !current.open });
            }}
            className={styles.section_container}
            key={section}
          >
            <h3
              className={`${
                isTabletOrMobile &&
                current.element === section &&
                current.open === true
                  ? styles.title_grey
                  : ""
              }`}
            >
              {section}
            </h3>
            <ul
              className={`${
                isTabletOrMobile &&
                current.element === section &&
                current.open === true
                  ? styles.section_visible
                  : styles.section_hidden
              }`}
            >
              {subSections.map((item) => (
                <li key={item.label}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
